import { useGetMyInvitationsQuery } from '@app-velocity/libs/teams-data-access';

export const useNotifications = (refetch = false) => {
  const { data: myInvitations, isLoading } = useGetMyInvitationsQuery(refetch);

  return {
    count: (myInvitations || []).length,
    myInvitations,
    isLoading,
  };
};
